/**
 * Show message
 * @param $store
 * @param action
 * @param opts
 */
const showMessage = ($store, action, opts) => {
  if (!opts.header || !opts.message) {
    return;
  }
  const messageOpts = {
    header: opts.header,
    message: opts.message,
  };
  messageOpts.autohide = typeof opts.autohide === 'boolean' ? opts.autohide : 3000;
  $store.commit(action, messageOpts);
};

/**
 * Show error message
 * @param $store
 * @param opts
 */
export const errorMessage = ($store, opts) => {
  opts.header = opts.header || 'Error';
  showMessage($store, 'addErrorMessage', opts);
};

/**
 * Show success message
 * @param $store
 * @param opts
 */
export const successMessage = ($store, opts) => {
  opts.header = opts.header || 'Success';
  showMessage($store, 'addSuccessMessage', opts);
};
